import { ImageHistoryLogsResponseItemModel, ImageHistoryTableInfoModel } from "../../app/data/documents/imageHistoryLogsModels";
export default interface ImageHistoryLogsState {
  requestStarted: boolean;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestError: string;
  requestCreator: string;
  recordItems: ImageHistoryLogsResponseItemModel[];
  recordsRequest: PaginationModel | null;
  downloadCsv: boolean;
  tableInfo: ImageHistoryTableInfoModel;
};

export const initialImageHistoryLogsState: ImageHistoryLogsState = {
  requestStarted: false,
  requestSucceed: false,
  requestFailed: false,
  requestError: "",
  requestCreator: "",
  recordItems: [],
  recordsRequest: null,
  downloadCsv: false,
  tableInfo: {title: "", description: "", sections: []}
};
export interface PaginationModel {
    page: number,
    last: number,
  };
  